import React from "react";
import AboutMe from "../components/main/AboutMe";

function AboutPage({toggle, setToggle}) {
  return (
    <div>
      <AboutMe toggle={toggle} setToggle={setToggle} />
    </div>
  );
}

export default AboutPage;
